import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold">Something went wrong</h1>
        <p className="mt-2 text-muted-foreground">
          We're experiencing some technical difficulties. Please try again
          later.
        </p>
      </div>
      <div className="flex gap-4">
        <Button onClick={() => window.location.reload()}>Refresh Page</Button>
        <Button variant="outline" onClick={() => navigate('/')}>
          Return Home
        </Button>
      </div>
    </div>
  );
};
